import { render, staticRenderFns } from "./ToggleCampusPanel.vue?vue&type=template&id=82c36d74&scoped=true&"
import script from "./ToggleCampusPanel.vue?vue&type=script&lang=js&"
export * from "./ToggleCampusPanel.vue?vue&type=script&lang=js&"
import style0 from "./ToggleCampusPanel.vue?vue&type=style&index=0&id=82c36d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c36d74",
  null
  
)

export default component.exports